import { FC } from "react"
import Grid from "@mui/material/Grid"
import MDBox from "components/MDBox"
import DetectionAlertGraph from "./components/DetectionAlertGraph"
import TenantInfo from "./components/TenantInfo"
import Memo from "./components/Memo"
import DashboardLayout from "pages/components/DashboardLayout"
import DashboardNavbar from "pages/components/DashboardNavbar"
import { AlertHistory } from "./components/AlertHistory"

import MDButton from "components/MDButton"
import Table from "@mui/material/Table"
import TableBody from "@mui/material/TableBody"
import TableCell from "@mui/material/TableCell"
import TableContainer from "@mui/material/TableContainer"
import TableHead from "@mui/material/TableHead"
import TableRow from "@mui/material/TableRow"
import { Card } from "@mui/material"

import { useState, useEffect } from "react"
import { useParams } from "react-router-dom"
import { getFrontMedicalRecord } from "../../api//front_medical_record"
//3時間ビュー
//import { getHistoryGraph } from "../../api/history_graph"
import { getMedicalRecordDetectListWeekly } from "../../api/get_medical_record_detect_list_weekly"
import { getOnline } from "../../api/online"
//バックアップとしてコメントアウト
/*
import { getMedicalRecordDetectList } from "../../api/get_medical_record_detect_list"
import { getMedicalRecordDetectListOneDay } from "../../api/get_medical_record_detect_list_oneday"
*/
import { MedicalRecordInfo } from "./components/TenantInfo"
import { useNavigate } from "react-router-dom"
import { useLoading } from "../LoadingContext"
import { AlertHistoryEvent } from "./components/AlertHistory/"
import { DetectionAlertEvent, DetectionRange } from "./components/DetectionAlertGraph/"
import { useConnectionError } from "../ConnectionErrorContext"
import HourlyOnRatioGraph, { OnRatioDataPoint } from "./components/HourlyOnRatioGraph"

export interface DetectList {
  filename: string
  date: string
  url: string
}

export interface DetectListOneDay {
  id: string
  create_date: number
  status: string
}

const TenantDetail: FC = () => {
  const events: DetectionAlertEvent[] = []
  const detectionRange: DetectionRange[] = []
  const { startLoading, stopLoading } = useLoading()
  const { showConnectionError } = useConnectionError()
  const navigate = useNavigate()
  const { facility_id } = useParams<{ facility_id: string }>()
  const { medical_record_id } = useParams<{ medical_record_id: string }>()

  const [medicalInfo, setMedicalRecordInfo] = useState<MedicalRecordInfo | null>(null)
  const [alertHistoryEvent, setAlertHistoryEvent] = useState<AlertHistoryEvent[] | null>(null)
  const [detectList, setDetectList] = useState<DetectList[]>([])
  const [detectListOneDay, setDetectListOneDay] = useState<DetectListOneDay[]>([])
  const [isAlertEvent, setIsAlertEvent] = useState<number>(0)
  const [medicalRecordDisplayType, setMedicalRecordDisplayType] = useState("-1")
  //3時間ビュー
  /*
  const [detectionAlertEvent, setDetectionAlertEvent] = useState<DetectionAlertEvent[] | null>(null)
  const [detectionRangeEvent, setDetectionRangeEvent] = useState<DetectionRange[] | null>(null)
  */
  const [onRatioData, setOnRatioData] = useState<OnRatioDataPoint[]>([])
  const [isPoc, setIsPoc] = useState<boolean>(true)

  let alertEventNow = 0

  if (localStorage.getItem("session_code") == "") {
    navigate("/login")
    return <></>
  }

  const fetchInfo = async () => {
    //バックアップとしてコメントアウト
    /*
    let intervalId: NodeJS.Timeout
    let medical_record_display_type = "0"
    */
    try {
      startLoading()
      const response = await getFrontMedicalRecord(
        medical_record_id ? medical_record_id : "",
        facility_id ? facility_id : ""
      )

      if (!response || !response.medical_record || !response.facility) {
        return
      }

      //バックアップとしてコメントアウト
      /*
      // 検知ログを収集するアカウントの場合には、追加で一覧を取得
      if (localStorage.getItem("medical_record_display_type") == "1" || localStorage.getItem("account_type") == "service") {
        // 開発者アカウントでここに来た場合、
        try {
          const response_detect_list = await getMedicalRecordDetectList(
            medical_record_id ? medical_record_id : ""
          )
          setDetectList(response_detect_list.reports)

          // 1分おきに最新のデータを取得する
          const fetchData = async () => {
            const currentPath = window.location.pathname
            const parts = currentPath.split("/")
            const currentIdFromUrl = parts[parts.length - 1]
            //console.log(currentIdFromUrl)
            //console.log(medical_record_id)
            if (currentIdFromUrl !== medical_record_id) {
              return
            }

            try {
              const id = medical_record_id ?? ""
              const response_detect_list_oneday = await getMedicalRecordDetectListOneDay(id)
              setDetectListOneDay(response_detect_list_oneday.reports)
              setTimeout(fetchData, 60000)
            } catch (e) {
              console.log(e)
            }
          }

          // 初回実行
          fetchData()

          setMedicalRecordDisplayType("1")
          medical_record_display_type = "1"
        } catch (e) {
          // 処理が成功していなければ、通常の表示
          setMedicalRecordDisplayType("0")
        }
      } else {
        // 通常の表示
        setMedicalRecordDisplayType("0")
      }
      */
      setMedicalRecordDisplayType("0")
      stopLoading()
      if (alertEventNow == 0) {
        //console.log("setIsAlertEvent 1")
        alertEventNow = 1
        setIsAlertEvent(1)
      }
      //console.log("last_detect :: " + response.medical_record.last_detect)
      //console.log("last_detect_date :: " + response.medical_record.last_detect_date)
      console.log(response.medical_record)
      const medicalRecord = response.medical_record
      const facility = response.facility

      const devices = medicalRecord.devices ?? []
      const devicesNow = medicalRecord.devices_now ?? []
      const devicePlaces = medicalRecord.device_places ?? []
      const settingDevicePlaces = medicalRecord.setting_device_places ?? []
      const pocStartDate = medicalRecord.poc_start_date ?? 0
      const birthday =
        medicalRecord.birthday === undefined || medicalRecord.birthday === null ? null : String(medicalRecord.birthday)

      setMedicalRecordInfo({
        id: medicalRecord.medical_record_id,
        room_no: medicalRecord.room_no,
        name: medicalRecord.name,
        initial: medicalRecord.initial,
        age: medicalRecord.age,
        birthday: birthday,
        facility_id: facility_id,
        facility_name: facility.name,
        address: facility.address,
        phone: medicalRecord.phone,
        is_poc: medicalRecord.is_poc,
        poc_start_date: medicalRecord.poc_start_date,
        devices: devices,
        devices_now: devicesNow,
        device_places: devicePlaces,
        setting_device_places: settingDevicePlaces,
        detection: medicalRecord.detection,
        alert: devices.length === 0 ? -2 : medicalRecord.device_state !== 1 ? 0 : 1, //一旦履歴から表示
        memo: medicalRecord.memo,
        stop_mail: medicalRecord.stop_mail,
        service_id: medicalRecord.service_id,
        last_detect: medicalRecord.last_detect,
        last_detect_date: medicalRecord.last_detect_date,
        //バックアップとしてコメントアウト
        medical_record_display_type: "0", //medical_record_display_type,
        effective_sensitivity_enabled: medicalRecord.effective_sensitivity_enabled,
        effective_sensitivity: medicalRecord.effective_sensitivity,
        effective_sensitivity_source: medicalRecord.effective_sensitivity_source,
        effective_detection_enabled: medicalRecord.effective_detection_enabled,
        effective_detection_period: medicalRecord.effective_detection_period,
        effective_detection_period_source: medicalRecord.effective_detection_period_source,
        effective_option_enabled: medicalRecord.effective_option_enabled,
        effective_option_period: medicalRecord.effective_option_period,
        effective_option_period_source: medicalRecord.effective_option_period_source,
        reload: fetchInfo
      })

      // 現在時刻（秒単位のUNIXタイムスタンプ）
      const now = Math.floor(Date.now() / 1000)
      // 30日間の秒数 (30日 * 24時間 * 60分 * 60秒)
      const POC_LIMIT_SECONDS = 30 * 24 * 60 * 60
      const isExpired = medicalRecord.is_poc === 1 && pocStartDate > 0 && now - pocStartDate >= POC_LIMIT_SECONDS

      if (isExpired) {
        return
      }
      setIsPoc(false)

      setAlertHistoryEvent(response.history ?? [])

      // オンラインかどうかの判定
      // デバイスが無いなら確認を行わない
      if (devices.length !== 0) {
        const onlineData = await getOnline(medical_record_id ? medical_record_id : "")
        setMedicalRecordInfo({
          id: response.medical_record.medical_record_id,
          room_no: response.medical_record.room_no,
          name: response.medical_record.name,
          initial: response.medical_record.initial,
          age: response.medical_record.age,
          birthday: birthday,
          facility_id: facility_id,
          facility_name: response.facility.name,
          address: response.facility.address,
          phone: response.medical_record.phone,
          is_poc: response.medical_record.is_poc,
          poc_start_date: response.medical_record.poc_start_date,
          devices: response.medical_record.devices,
          devices_now: response.medical_record.devices_now,
          device_places: response.medical_record.device_places,
          setting_device_places: response.medical_record.setting_device_places,
          detection: response.medical_record.detection,
          alert: onlineData.online,
          memo: response.medical_record.memo,
          stop_mail: response.medical_record.stop_mail,
          service_id: response.medical_record.service_id,
          last_detect: response.medical_record.last_detect,
          last_detect_date: response.medical_record.last_detect_date,
          //バックアップとしてコメントアウト
          medical_record_display_type: "0", //medical_record_display_type,
          effective_sensitivity_enabled: medicalRecord.effective_sensitivity_enabled,
          effective_sensitivity: medicalRecord.effective_sensitivity,
          effective_sensitivity_source: medicalRecord.effective_sensitivity_source,
          effective_detection_enabled: medicalRecord.effective_detection_enabled,
          effective_detection_period: medicalRecord.effective_detection_period,
          effective_detection_period_source: medicalRecord.effective_detection_period_source,
          effective_option_enabled: medicalRecord.effective_option_enabled,
          effective_option_period: medicalRecord.effective_option_period,
          effective_option_period_source: medicalRecord.effective_option_period_source,
          reload: fetchInfo
        })
      }
    } catch (error: any) {
      if (error.response && error.response.status === 401) {
        navigate("/login")
      } else if (!error.response) {
        showConnectionError(true)
      }
    } finally {
      stopLoading()
    }
  }

  useEffect(() => {
    const historyGraph = async () => {
      try {
        const historyGraphData = await getMedicalRecordDetectListWeekly(medical_record_id ? medical_record_id : "")
        //console.log(historyGraphData.reports)
        setOnRatioData(historyGraphData.reports)

        //3時間ビュー
        /*
        const historyGraphDataThree = await getHistoryGraph(medical_record_id ? medical_record_id : "")
        const alerts = historyGraphDataThree.alerts || []
        const detects = historyGraphDataThree.detects || []
        const detectRange = historyGraphDataThree.detect_range || []

        // alerts と detects を統合して、events 配列を作成
        alerts.forEach((alertTimestamp: number) => {
          events.push({
            timestamp: new Date(alertTimestamp * 1000).toISOString(),
            eventType: "ALERT"
          })
        })

        detects.forEach((detectTimestamp: number) => {
          events.push({
            timestamp: new Date(detectTimestamp * 1000).toISOString(),
            eventType: "DETECTION"
          })
        })

        detectRange.forEach((detectRangeData: number[]) => {
          detectionRange.push({
            start:
              detectRangeData[0] != -1 ? new Date(detectRangeData[0] * 1000).toISOString() : "2000-01-01T00:00:00.000Z",
            end:
              detectRangeData[1] != 9999999999
                ? new Date(detectRangeData[1] * 1000).toISOString()
                : "2999-12-31T23:59:59.999Z"
          })
        })

        // 最終的に events を状態にセット
        setDetectionAlertEvent(events)
        setDetectionRangeEvent(detectionRange)
        */
      } catch (error: any) {
        if (error.response && error.response.status === 401) {
          navigate("/login")
        } else if (!error.response) {
          showConnectionError(true)
        }
      } finally {
        //console.log("setIsAlertEvent 2")
        alertEventNow = 2
        setIsAlertEvent(2)
      }
    }
    fetchInfo()
    historyGraph()
  }, [])

  // ロケール対応の日付フォーマット関数
  const formatDateWithLocale = (timestamp: number, locale: string = "ja-JP"): string => {
    const date = new Date(timestamp * 1000)
    return new Intl.DateTimeFormat(locale, {
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
      hour12: false // 24時間形式
    }).format(date)
  }

  return (
    <DashboardLayout>
      <MDBox>
        <DashboardNavbar absolute={true} />
      </MDBox>
      <MDBox mt={2}>
        <TenantInfo {...medicalInfo} />
      </MDBox>
      {/* 30日間のPOC期間を過ぎている場合は、以降の内容は表示しない */}
      {!isPoc && (
        <>
          <MDBox mt={4}>
            <Memo
              key="MedicalRecordMemo"
              id={medical_record_id ? medical_record_id : ""}
              body={medicalInfo ? (medicalInfo.memo ? medicalInfo.memo : "") : ""}
              stop_mail={medicalInfo ? (medicalInfo.stop_mail ? medicalInfo.stop_mail : 0) : 0}
            />
          </MDBox>
          {medicalRecordDisplayType === "0" && (
            <MDBox mt={4}>
              <Grid container spacing={3}>
                <Grid item xs={12}>
                  <HourlyOnRatioGraph onRatios={onRatioData ?? []} initialized={isAlertEvent} />
                </Grid>
              </Grid>
            </MDBox>
          )}
          {/* 3時間ビュー */}
          {/*medicalRecordDisplayType === "0" && (
            <MDBox mt={4}>
              <Grid container spacing={3}>
                <Grid item xs={12}>
                  <DetectionAlertGraph
                    events={detectionAlertEvent ? detectionAlertEvent : []}
                    detectionRange={detectionRangeEvent ? detectionRangeEvent : []}
                    initialized={isAlertEvent}
                  />
                </Grid>
              </Grid>
            </MDBox>
          )*/}
          <MDBox mt={4}>
            <Grid container spacing={3}>
              <Grid item xs={12}>
                <AlertHistory
                  key="tenant_alert_history"
                  info={medicalInfo}
                  events={alertHistoryEvent ? alertHistoryEvent : []}
                />
              </Grid>
            </Grid>
          </MDBox>
          {medicalRecordDisplayType === "1" && (
            <>
              <Card style={{ marginTop: "20px" }}>
                <MDBox style={{ fontSize: "1.25rem", fontWeight: "600" }} pt={3} px={3}>
                  検知ログ
                </MDBox>
                <TableContainer sx={{ overflowX: "auto", overflowY: "auto", height: "200px", marginTop: "20px" }}>
                  <Table stickyHeader>
                    <TableHead sx={{ position: "sticky", display: "table-header-group", zIndex: 3 }}>
                      <TableRow
                        sx={{
                          "& .MuiTableCell-root": {
                            fontSize: "0.875rem",
                            color: "text.primary",
                            fontWeight: "bold",
                            backgroundColor: "#FFFFFF"
                          }
                        }}
                      >
                        <TableCell align="left">日時</TableCell>
                        <TableCell align="left">ステータス</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {detectListOneDay.map((row, index) => (
                        <TableRow
                          key={index}
                          sx={{
                            "& .MuiTableCell-root": {
                              fontSize: "0.875rem",
                              color: "text.primary",
                              fontWeight: "normal",
                              zIndex: 0
                            }
                          }}
                        >
                          <TableCell align="left">
                            <div
                              style={{
                                minWidth: "200px",
                                width: "10vw",
                                whiteSpace: "nowrap",
                                overflow: "hidden",
                                textOverflow: "ellipsis"
                              }}
                              title={row.id || undefined}
                            >
                              {formatDateWithLocale(row.create_date)}
                            </div>
                          </TableCell>
                          <TableCell align="left">
                            <div style={{ minWidth: "200px" }}>{row.status}</div>
                          </TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </TableContainer>
              </Card>
              <Card style={{ marginTop: "20px" }}>
                <MDBox style={{ fontSize: "1.25rem", fontWeight: "600" }} pt={3} px={3}>
                  検知ログ(履歴)
                </MDBox>
                <TableContainer sx={{ overflowX: "auto", overflowY: "auto", height: "200px", marginTop: "20px" }}>
                  <Table stickyHeader>
                    <TableHead sx={{ position: "sticky", display: "table-header-group", zIndex: 3 }}>
                      <TableRow
                        sx={{
                          "& .MuiTableCell-root": {
                            fontSize: "0.875rem",
                            color: "text.primary",
                            fontWeight: "bold",
                            backgroundColor: "#FFFFFF"
                          }
                        }}
                      >
                        <TableCell align="left">ファイル名</TableCell>
                        <TableCell align="left">日付</TableCell>
                        <TableCell align="left">URL</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {detectList.map((row, index) => (
                        <TableRow
                          key={index}
                          sx={{
                            "& .MuiTableCell-root": {
                              fontSize: "0.875rem",
                              color: "text.primary",
                              fontWeight: "normal",
                              zIndex: 0
                            }
                          }}
                        >
                          <TableCell align="left">
                            <div
                              style={{
                                minWidth: "200px",
                                width: "10vw",
                                whiteSpace: "nowrap",
                                overflow: "hidden",
                                textOverflow: "ellipsis"
                              }}
                              title={row.filename || undefined}
                            >
                              {row.filename}
                            </div>
                          </TableCell>
                          <TableCell align="left">
                            <div style={{ minWidth: "50px" }}>{row.date}</div>
                          </TableCell>
                          <TableCell align="left">
                            <MDButton
                              variant="gradient"
                              color="info"
                              size="medium"
                              onClick={() => window.open(row.url, "_blank")}
                            >
                              DL
                            </MDButton>
                          </TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </TableContainer>
              </Card>
            </>
          )}
        </>
      )}
    </DashboardLayout>
  )
}

export default TenantDetail
